import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["imagePreview", "removeFlag"];

  declare imagePreviewTarget: HTMLElement;
  declare removeFlagTarget: HTMLInputElement;

  markForRemoval(): void {
    this.removeFlagTarget.value = "1";
    this.imagePreviewTarget.classList.add("is-hidden");
  }
}
